module.exports = __webpack_public_path__ + "img/2.a0d748ec.png";